import { getUserNotificationCount } from '@common/Services/client-data-service';

const notificationCountSpan = () => <JQuery<HTMLSpanElement>>$('#NotificationCount');

export default async function init(): Promise<void> {
	if (notificationCountSpan().length === 0) return;

	const notificationCount = await getUserNotificationCount();

	if (notificationCount === 0) return;

	notificationCountSpan().removeClass('d-none');
	notificationCountSpan()[0].textContent = notificationCount.toString();
}

$(init);
